"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelFieldSelectList = exports.FormModelMutatorSelectList = void 0;
const core_api_1 = require("@ikegps/core-api");
const form_field_1 = require("./form.field");
class FormModelMutatorSelectList extends form_field_1.FormModelMutatorField {
    getOptions() {
        const stateValue = this.field.stateValue;
        if (Array.isArray(stateValue.options)) {
            return JSON.parse(JSON.stringify(stateValue.options));
        }
        return [
            {
                text: FormModelFieldSelectList.UNSELECTED_TEXT,
                value: FormModelFieldSelectList.UNSELECTED_VALUE,
                color: FormModelFieldSelectList.UNSELECTED_COLOR,
            },
        ];
    }
    option(option, index = -1) {
        const options = this.getOptions();
        if (index === -1 || index > options.length - 1) {
            options.push(option);
        }
        else {
            options[index] = option;
        }
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { options }));
    }
    remove(index) {
        const options = this.getOptions();
        if (index > options.length) {
            throw new Error('Index is out of bounds ' + index + ' > ' + options.length);
        }
        options.splice(index, 1);
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { options }));
    }
}
exports.FormModelMutatorSelectList = FormModelMutatorSelectList;
class FormModelFieldSelectList extends form_field_1.FormModelField {
    static isSelectList(field) {
        return field.type === core_api_1.IkeFieldType.SELECT_LIST;
    }
    get Mutator() {
        if (this._SLMutator == null) {
            this._SLMutator = new FormModelMutatorSelectList(this);
        }
        return this._SLMutator;
    }
    get options() {
        return (this.stateValue.options || [
            {
                text: FormModelFieldSelectList.UNSELECTED_TEXT,
                value: FormModelFieldSelectList.UNSELECTED_VALUE,
                color: FormModelFieldSelectList.UNSELECTED_COLOR,
            },
        ]);
    }
    /**
     * Choose the first element in the array as the unselected value
     * Other wise use the default `unselected`
     */
    get unselectedValue() {
        const options = this.options;
        if (!Array.isArray(options) || options.length === 0) {
            return FormModelFieldSelectList.UNSELECTED_VALUE;
        }
        return options[0].value;
    }
    createOption(text, value, color) {
        this.Mutator.option({ text, value, color });
    }
    findOption(value) {
        const options = this.options;
        for (var i = 0; i < options.length; i++) {
            const opt = options[i];
            if ((opt === null || opt === void 0 ? void 0 : opt.value) === value) {
                return opt;
            }
        }
        // Unselected option not found, use the default
        if (value === FormModelFieldSelectList.UNSELECTED_VALUE) {
            return {
                text: FormModelFieldSelectList.UNSELECTED_TEXT,
                value: FormModelFieldSelectList.UNSELECTED_VALUE,
                color: FormModelFieldSelectList.UNSELECTED_COLOR,
            };
        }
        return null;
    }
}
exports.FormModelFieldSelectList = FormModelFieldSelectList;
FormModelFieldSelectList.UNSELECTED_VALUE = 'unselected';
FormModelFieldSelectList.UNSELECTED_TEXT = 'Unselected';
FormModelFieldSelectList.UNSELECTED_COLOR = '#a0aec0';
//# sourceMappingURL=form.select.list.js.map